/**
 * Calculates total height of children for a given element collection
 * @param {HTMLElement[]} HTMLCollection
 */
export const checkContentHeight = (HTMLCollection) => {
    let acc = 0

    for (let i = 0; i < HTMLCollection.length; i++) {
        const elm = HTMLCollection[i]
        const elmStyle = window.getComputedStyle(elm)
        const verticalMargins
      = parseInt(elmStyle.getPropertyValue('margin-top'))
      + parseInt(elmStyle.getPropertyValue('margin-bottom'))
        const height = elm.offsetHeight || 0

        acc += height + verticalMargins
    }

    return acc
}
